import React from 'react';

import { TrialSignupLoader, TrialSignupContent } from './components';
import { FreeTrialWrapper } from '../../components/free-trial-wrapper';
import { useTrialInviteGate } from './components/trial-signup-content/hooks/useTrialInviteGate';

export const TrialSignup = () => {
  const { isVerified, inviteEmail, inviteId, inviteVerificationCode } =
    useTrialInviteGate();

  if (!isVerified) return <TrialSignupLoader />;

  return (
    <FreeTrialWrapper>
      <TrialSignupContent
        inviteEmail={inviteEmail}
        inviteId={inviteId}
        inviteVerificationCode={inviteVerificationCode}
      />
    </FreeTrialWrapper>
  );
};
